module.exports = __webpack_public_path__ + "static/media/circle icon-5.1c8363c6.png";